export default __webpack_public_path__ + "static/media/purple_type_icon.7241e3be.svg";